import React, { useState } from 'react';
import { useWallet } from '@/contexts/WalletContext';
import { checkMetaMaskAvailability } from '@/utils/metamask';
import Button from '@/components/ui/Button';
import Card from '@/components/ui/Card';
import styles from '@/styles/components/wallet/ConnectWalletInterface.module.css';


const ConnectWalletInterface: React.FC = () => {
  const { connect, state } = useWallet();
  const [isConnecting, setIsConnecting] = useState(false);



  const handleMetaMaskConnect = async () => {
    setIsConnecting(true);
    try {
      await connect();
    } catch (error) {
      console.error('Connection failed:', error);
    } finally {
      setIsConnecting(false);
    }
  };

  const isMetaMaskAvailable = checkMetaMaskAvailability();

  return (
    <div className={styles.container}>
      <div>
        <h2 className={styles.title}>Connect Your Wallet</h2>
        <p className={styles.description}>
          Connect your cryptocurrency wallet to view balances, manage tokens, and make deposits.
        </p>
      </div>

      {/* Error message display */}
      {state.error && (
        <div className={styles.errorMessage}>
          {state.error}
        </div>
      )}

      <div className={styles.walletOptions}>
        {/* MetaMask Option */}
        <Card
          variant="flat"
          padding="none"
          interactive={isMetaMaskAvailable}
          onClick={isMetaMaskAvailable ? handleMetaMaskConnect : undefined}
        >
          <div className={isMetaMaskAvailable ? styles.metaMaskOption : styles.metaMaskOptionDisabled}>
            <div className={styles.metaMaskIcon}>
              <img
                src="/icons/profile_page/wallet/metamask.svg"
                alt="MetaMask"
                style={{ width: '24px', height: '24px' }}
              />
            </div>
            <div className={styles.metaMaskText}>
              <h3 className={styles.metaMaskTitle}>MetaMask</h3>
              <p className={styles.metaMaskDesc}>
                {isMetaMaskAvailable 
                  ? 'Connect using MetaMask browser extension'
                  : 'MetaMask extension not detected'
                }
              </p>
            </div>
            {isMetaMaskAvailable && (
              <Button
                variant="primary"
                size="sm"
                isLoading={isConnecting}
                disabled={isConnecting}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMetaMaskConnect();
                }}
              >
                {isConnecting ? 'Connecting...' : 'Connect'}
              </Button>
            )}
          </div>
        </Card>

        {/* Installation guidance when MetaMask is not available */}
        {!isMetaMaskAvailable && (
          <div className={styles.installationGuide}>
            <h3 className={styles.installationTitle}>Install MetaMask</h3>
            <div className={styles.installationSteps}>
              <p style={{ margin: '0 0 12px 0' }}>
                To connect your wallet, you need to install the MetaMask browser extension:
              </p>
              <ol style={{ margin: '0 0 16px 0', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>
                  Visit{' '}
                  <a
                    href="https://metamask.io/download/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.installationLink}
                  >
                    metamask.io/download
                  </a>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Install the extension for your browser
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Create a new wallet or import an existing one
                </li>
                <li>Refresh this page and click "Connect" above</li>
              </ol>
              <p style={{ margin: 0, fontSize: '13px', fontStyle: 'italic' }}>
                Make sure to keep your seed phrase secure and never share it with anyone.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectWalletInterface;
